<template>
  <div>
    <div class="m_context">
      <el-row  style="margin-bottom: 20px;">
        <el-col :span="12" style="">
          <div style='margin-left:24px;'>
            <!-- // todo 翻译 -->
            <el-button @click="pushAction(0)">{{$t('app_mulPush')}}<span>({{multipleSelection.length || 0}})</span></el-button>
            <el-button @click="pushAction(1)">{{$t('app_pushAll')}}</el-button>
            <el-button @click="pushAction(2)">文件导入推送</el-button>

            <el-tooltip class="item" effect="dark" :content="$t('app_rsfivemin')" placement="right">
              <el-button type="primary" @click="shuaxin" size=""><i class="fa fa-refresh" aria-hidden="true"></i>&nbsp;{{$t('lin_global.shuaxin')}}</el-button>
            </el-tooltip>
          </div>
        </el-col>
        <el-col :span="4">
          <div style='margin-left:24px;'><MechanismSelector style='width:100%;' :data="mechanismData"></MechanismSelector></div>
        </el-col>

        <el-col :span="4">
          <div style='margin-left:16px;margin-right:16px;'><el-select style='width:100%' v-model="value2" @change="statusChange" placeholder="">
            <el-option
              v-for="item in options2"
              :label="item.label"
              :key="item.id"
              :value="item.value">
            </el-option>
          </el-select></div>
        </el-col>
        <el-col :span="4" style="padding-right:24px;">
          <div><el-input
            :placeholder="$t('lin_global.label_no') + '、' + $t('app_name')"
            icon="search"
            v-model="dvName"
            :on-icon-click="handleIconClick"
            @keyup.enter.native="focusEvent(handleIconClick)">
          </el-input></div>
        </el-col>

      </el-row>

      <el-row>

      </el-row>

      <!-- terminalName -->

      <el-table
        :data="arrdata"
        id="tp"
        border
        class=''
        style="width:100%;"
        @selection-change="handleSelectionChange"
        ref="arrdata"
        v-loading="loading"
        @sort-change = "sortChane"
        :element-loading-text="$t('lin_global.loading')">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="terminalName"
          sortable
          :label="$t('lin_global.label_name')">
        </el-table-column>
        <el-table-column
          prop="terminalNo"
          :label="$t('lin_global.label_no')"
          sortable = "custom"
          >
        </el-table-column>
        <el-table-column
          :label="$t('lin_global.ter_status')"
          align='center'
          >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.terminalStatus == 1 " type="success" size="mini">{{$t('lin_global.online')}}</el-tag>
            <el-tag v-if="scope.row.terminalStatus == 2 " type="danger" size="mini">{{$t('lin_global.offline')}}</el-tag>
            <el-tag v-if="scope.row.terminalStatus == 0 " type="gray" size="mini">{{$t('lin_global.new_add')}}</el-tag>
            <el-tag v-if="scope.row.terminalStatus == 3 " type="warning" size="mini">{{$t('app_sleep')}}</el-tag>
          </template>
        </el-table-column>

        <el-table-column
          prop="mechName"
          :label="$t('lin_global.label_areaid')"
          width="220">
        </el-table-column>
      </el-table>
      <div class="page_content">
        <el-pagination style='float:right;'
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="currentPage"
                       :page-sizes="[10,50,100]"
                       :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="totalRecords">
        </el-pagination>
      </div>
    </div>


    <el-dialog class='gDia' :title="$t('app_pushAll')" v-model="hasCoverWarn" size="tiny" top="15%" :show-close="true">
      <div>{{tipMessage}}</div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="hasCoverWarn = false">{{$t('lin_btn.cancel')}}</el-button>
        <el-button size="small" @click="confirmToPush(1)">{{$t('terminal.details.cover_send')}}</el-button>
        <el-button size="small" @click="confirmToPush(0)" type="info">{{$t('terminal.details.skip_send')}}</el-button>
      </div>
    </el-dialog>

    <el-dialog class='gDia' :title="$t('app_pushAll')" v-model="uploadModalShow" size="tiny" top="15%" :show-close="true">
      <el-form ref="addForm" class='gForm' id="addForm" :model="form" label-width="12.5%">
        <el-form-item>
          <div>{{$t('app_mdFile')}}</div>
          <a class='aSc' style='' :href="downUrl" :title="$t('app_downExp')" target="_blank">
            {{$t('app_downTplFile')}}
          </a>

          <el-upload
            ref="upload"
            class="upload-demo"
            name='fileUpload'
            :action="fileUploadUrl"
            :before-upload="srcBefore"
            :on-success="srcSuccess"
            :file-list="srcList">
            <el-button size="small" type="primary">{{$t('app_clickUpdate')}}</el-button>
          </el-upload>

        </el-form-item>

        <el-form-item>
          <div>{{$t('app_deviceNum')}}</div>
          <label>{{dvNum}}{{$t('app_amechine')}}</label>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="uploadModalShow = false">{{$t('lin_btn.cancel')}}</el-button>
        <el-button size="small" @click="doUploadPush" type="info">确认推送</el-button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
  import JQuery from 'jquery'
  import axios from 'axios'
  import { baseurl,url,focusEvent,urlAssets } from '../../../api/url'
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
  export default{
    components: {
      MechanismSelector
    },
    data(){
      var that = this
      return{
        uploadPushParams: null,
        form:{
          token:localStorage.getItem('user'),
          memo:'',
          type:'0',
          targetId:'',
          ota_rom_id:'',
          fileNo: ''
        },
        // 推送时, 服务端是否返回300(警告覆盖)
        hasCoverWarn: false,
        // 推送类型: 任务类型:1.应用推送； 2.OTA推送； 3.ROM推送； 4.固件推送； 5.广告推送； 6.动画推送； 10.launcher推送。
        taskType: null,
        // 提示文字
        tipMessage: that.$t('pushTip.pushType0'),
        // 推送确认信息
        uploadModalShow: false,
        selectedMechanismObject: null,
        mechanismData: {
          optValue: true,
          callback (value) {
            that.selectedMechanismObject = value
            that.value1 = value.id
            that.getData(1,that.input1,that.value1,that.value2,that.orderValue);
          }
        },
        exInfo: {},
        dvNum: 0,
        exFileName: '',
        dataUpload:null,
        dvName: '',
        orderValue:'',
        terminalName: '',
        disabled:true,
        focusEvent: focusEvent,
        importTemplate: `${urlAssets.prefix}tms-server-web/model/terminals.xlsx`,
        fileList:[],
        action:'',
        srcList: [],
        areaList1: [],
        excelUploadUrl: '',
        areaList: [],
        importForm: {
          'areaid': '',
          'uploadify': null
        },
        statusinfoLoading: false,
        importTermVisible: false,
        importIsSubmit: false,
        currentPage: 1,
        pageSize: 10,
        totalRecords: 0,
        loading: true,
        reserverSelection: true,
        input1:'',
        value1: '',
        value2: '',
        multipleSelection: [],
        options2: [{
          value: '',
          label: this.$t('lin_global.all_status')
        }, {
          value: '0',
          label: this.$t('lin_global.new_add')
        }, {
          value: '1',
          label: this.$t('lin_global.online')
        }, {
          value: '2',
          label: this.$t('lin_global.offline')
        },
        {
          value: '3',
          label: this.$t('app_sleep')
        }
        ],
        areaid: '',
        arrdata:[],
        currentFileId: null
      }
    },
    computed: {
      fileUploadUrl () {
        return "http://172.16.7.51:8686/tms-server-web/import/terminalList.do"
//        return this.$fileExcelUlUrl
      },
      downUrl () {
        return this.$host + '/tms-server-web/model/terminalNos.xlsx'
      },
      justSelectMechanism () {
        return (this.selectedMechanismObject && this.value2 === '' && this.dvName === '') || false
      }
    },
    methods:{
      doUploadPush () {
        let that = this
        that.uploadModalShow = false
        that.doPush(that.uploadPushParams)
      },
      srcSuccess (res, file) {
        window[this.$route.path] = ''
        //console.log('exres', res)
        if (res.status === 200) {
          this.srcList = [{name: file.name}]
          this.exInfo = res.data
          this.exInfo.file = file.name
          this.form.fileNo = res.data.fileNo
          //this.hBlur('fm')
          this.dvNum = res.data.terNums
        } else {
          if (this.exInfo.file) {
            this.srcList = [{name: this.exInfo.file}]
          } else {
            this.srcList = []
          }
          this.$message.error(res.message)
        }
      },
      srcBefore (file) {
        // console.log(file)
        window[this.$route.path] = 1
        /*var name = file.name
        if (name === 'part0.zip') {
          window[this.$route.path] = 1
          return true
        } else {
          this.$message(this.$t('app_fileNameOnly') + 'part0.zip')
          return false
        } */
      },
      // 确认推送
      confirmToPush (isCover) {
        let that = this
        switch (isCover) {
          case 0:
            // 跳过推送
            console.log('跳过更新')
            break;
          case 1:
            // 覆盖推送
            console.log('覆盖更新')
            break;
        }

        let oldParams = this.$getWPage('confirmParams')
        let params = {
          taskId: oldParams.taskId,
          pushParam: oldParams.pushParam,
          isCover: isCover
        }

        this.$confirmToPushAction(params, (res) => {
          that.hasCoverWarn = false
          if (res.status === 200) {
            that.$message.success(that.$t('pushTip.pushSuccess'))
          } else {
            // todo 翻译
            that.$message.error(res.message)
          }
        })
      },
      doPush (params, message) {
        let that = this
        if (that.form.fileNo) {
          params.fileNo = that.form.fileNo
        }
        that.$pushGlobalAction(params, (res) => {
          if (res.status === 200) {
            that.$message.success(res.message)
          } else if (res.status === 300) {
            // 提示覆盖
            that.hasCoverWarn = true
            that.tipMessage = message.replace(/{nums}/, res.data.nums)
            that.$setWPage('confirmParams', res.data)
          } else {
            that.$message.error(res.message)
          }
        })
      },
      pushAction (pushType) {
        let that = this
        let params = {}

        params.taskType = that.taskType
        params.pushType = pushType

//        let tString = "本次推送有{nums}台设备已完成推送, 您要跳过这些设备吗?";
//
//        tString = tString.replace(/{nums}/, 123)
//        console.log(tString)

        switch (that.taskType) {
          case '1':
            // 应用推送
            break;
          case '2':
            // OTA推送
            let otaInfo = this.$getWObj().otaPushInfo
            params.objId = otaInfo.id
            break;
          case '3':
            // ROM推送
            break;
          case '4':
            // 固件推送

            break;
          case '5':
            // 广告推送
            break;
          case '6':
            // 动画推送
            let info = this.$getWObj().animatePushInfo
            params.objId = info.animatId
            break;
          default:
            // launcher推送
            break;
        }


//        that.tipMessage = this.$t('pushTip.pushType0')

        // pushTask : 任务类型:1.应用推送； 2.OTA推送； 3.ROM推送； 4.固件推送； 5.广告推送； 6.动画推送； 10.launcher推送。

//        const doPush = function (params, message) {
//          that.$pushGlobalAction(params, (res) => {
//            if (res.status === 200) {
//              that.$message.success(res.message)
//            } else if (res.status === 300) {
//              // 提示覆盖
//              that.hasCoverWarn = true
//              that.tipMessage = message.replace(/{nums}/, res.data.nums)
//              that.$setWPage('confirmParams', res.data)
//            } else {
//              that.$message.error(res.message)
//            }
//          })
//        }

        // pushType : 0当前勾选的设备、1当前查询条件所有设备、2当前导入的设备
        switch (pushType) {
          case 0:
            // 勾选设备推送
            // terminalNos必填
            let terminalNoArray = [];
            if (this.multipleSelection.length === 0) {
              this.$message.error(this.$t('terminal.add.place_terminal'))
              return false
            }
            for (let i = 0; i < this.multipleSelection.length; i++) {
              terminalNoArray.push(this.multipleSelection[i].terminalNo)
            }

            params.terminalNos = terminalNoArray.join(',')

            that.doPush(params, this.$t('pushTip.pushType0'))
            break;
          case 1:
            // 根据查询条件全部推送
            // mechId必填
            params.mechId = that.value1
            // terminalStatus必填
            params.terminalStatus = that.value2
            // terminalNo必填
            params.terminalNo = that.dvName

            //

            let configText;
            if (!that.selectedMechanismObject) {
              configText = that.$t('pushTip.push_all')
            } else if (that.justSelectMechanism) {
              configText = that.$t('pushTip.push_all_by_mem')
              console.log(configText)
              configText = configText.replace(/{nums}/, 111)
              configText = configText.replace(/{mem}/, that.selectedMechanismObject.name)
            }


            this.$confirm(configText, that.$t('mao_global.tip.text'), {
              confirmButtonText: '确认推送',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
//              this.$message({
//                type: 'success',
//                message: '删除成功!'
//              });
              that.doPush(params)
            }).catch(() => {});
            break;
          default:
            // 当前导入的设备推送
            // fileNo 必填
            that.uploadModalShow = true
            that.uploadPushParams = params
            break;
        }
      },
      powerIcon (vl) {
        return !vl ? "color:#FF4949" : "color: null"
      },
      exCancel () {
        this.importTermVisible = false
        this.disabled = true
        if(this.exFileName) {
          this.$router.push({path: '/'})
          this.$router.go(-1)
        }
      },
      shuaxin:function(){
        this.getData(1,this.input1,this.value1,this.value2,this.orderValue);
      },
      sortChane:function(val){
        if(val.order === "descending"){
          this.orderValue = "desc"
        }else if(val.order === "ascending"){
          this.orderValue = "asc"
        }else{
          this.orderValue = '';
        }
        this.getData(this.currentPage,this.input1,this.value1,this.value2,this.orderValue)
      },
      handleSizeChange: function (val) {
        this.pageSize = val
        this.getData(this.currentPage,this.input1,this.value1,this.value2,this.orderValue)
      },
      handleCurrentChange: function (val) {
        this.currentPage = val
        this.getData(this.currentPage,this.input1,this.value1,this.value2,this.orderValue)
      },
      statusChange(){
        this.getData(1,this.input1,this.value1,this.value2,this.orderValue)
      },
      handleIconClick(){
        this.getData(1,this.input1,this.value1,this.value2,this.orderValue)
      },
      handleSelectionChange(val){
        this.multipleSelection = val
      },
      batchDeleteRow(){
        //let self = this
        this.$confirm(this.$t('terminal.list.delete_tips'), this.$t('lin_btn.tips'), {
          confirmButtonText: this.$t('lin_btn.confirm'),
          cancelButtonText: this.$t('lin_btn.cancel'),
          type: 'warning'
        }).then(() => {
          let ids = []
          if (this.multipleSelection.length === 0) {
            this.$message.error(this.$t('terminal.list.empty_tips'))
            return false
          }
          for (let i = 0; i < this.multipleSelection.length; i++) {
            ids.push(this.multipleSelection[i].terminalId)
          }
          let rq = {
            ids: ids.join(',')
          }
          axios.post(`${baseurl}/terminal/delete.do`, rq).then((response)=> {
            let rs = response.data
            if (rs.status == 200) {
              this.$message.success(this.$t('lin_global.delete_success'))
              this.getData(this.currentPage,this.input1,this.value1,this.value2,this.orderValue)
            } else {
            }
          }).catch(function (error) {
          })
        }).catch(() => {

        })
      },
      getData(page,no,areaid,status,order){
        let that = this
        //this.statusinfoLoading=true;
        this.loading = true;
        this.currentPage = page;
        var params = {
          page:page,
          rows:this.pageSize,
          fileMechId: this.currentFileId || '',
          mechId: that.value1 || '',
          token: localStorage.getItem('user') || '',
          terminalStatus:status,
          terminalNo: this.dvName
        }
        console.log(params)
        axios.post(`${baseurl}/push_manage/push_terList.do`, params).then(res=> {
          if(res.data.status == 200){
            this.arrdata = res.data.data;
            this.totalRecords = res.data.total;
            this.loading = false;
            for(var i = 0;i<res.data.data.length;i++){
              if(res.data.data[i].terminalStatus == 1){
                res.data.data[i]['disable'] = false;
              }else{
                res.data.data[i]['disable'] = true;
              }
            }
          }else{
            this.loading = false;
          }

        }).catch(function (error) {

        })

      },
      getFileIdByTaskType (taskType) {
        let that = this
        switch (taskType) {
          case '1':
            // 应用推送
            break;
          case '2':
            // OTA推送
            let otaInfo = this.$getWObj().otaPushInfo
            that.currentFileId = otaInfo.mechanismId
            break;
          case '3':
            // ROM推送
            break;
          case '4':
            // 固件推送

            break;
          case '5':
            // 广告推送
            break;
          case '6':
            // 动画推送
            let info = this.$getWObj().animatePushInfo
            that.currentFileId = info.animatId
            break;
          default:
            // launcher推送
            break;
        }
      }
    },
    mounted () {
      let that = this
      this.taskType = this.$route.params.type

//      this.getFileIdByTaskType(this.taskType)

      if (this.taskType !== '6') {
        that.getFileIdByTaskType(this.taskType)
      }

      // 判断路由是否有参数, 如果有则证明带查询状态的路由
      // 直接就根据状态查询数据
      var c = this.$store.getters.r_param;
      if (c) {
        this.$store.dispatch('setParam',null)
        this.value2 = c+''
        this.statusChange()
      } else {
        this.getData(1,'','','','');
      }
      let timer = setInterval(()=>{
        this.getData(1,this.input1,this.value1,this.value2,this.orderValue);
      }, 300000 ) //300000
      localStorage.setItem("timer",timer);
      if (localStorage.getItem("system_lang")){
        var lang = localStorage.getItem("system_lang");
        this.action = `${baseurl}/terminal/importTers.do`+"?language="+lang + '&token=' + localStorage.user
      }
    }
  }
</script>
<style>
  #tp td{
    cursor: pointer;
  }
</style>
<style scoped>
  .filename {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    display: block;
    font-size: inherit;
    height: 36px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    width: 100%;
  }
  .uploader input[type=file] {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    border: 0;
    z-index: 20;
    padding: 0;
    margin: 0;
    height: 30px;
    cursor: pointer;
    filter: alpha(opacity=0);
    -moz-opacity: 0;
    -khtml-opacity: 0;
    opacity: 0;
  }



</style>





// WEBPACK FOOTER //
// pushToTerminal.vue?0cec100a